
;(function($) {

    var sggbisCard = $.fn.sggbisCard = function(options) {
        sggbisCard.elements = this;
        sggbisCard.mobileMode = false;
        sggbisCard._apply();
        sggbisCard._checkMobile();
        return this;
    };


    sggbisCard._checkMobile = function(){
        if(($(document).width() < 768)){
            sggbisCard.mobileMode = true;
        } else {
            sggbisCard.mobileMode = false;
        }
    }

    sggbisCard._apply = function() {


        if(this.elements != undefined){

            this.elements.each(function(elt){

                var keepRatio = true;

                if($(this).hasClass('newsLatest') && sggbisCard.mobileMode){
                    keepRatio = false;
                }

                if(keepRatio) {
                    $(this).keepRatio();
                }


                if($(this).innerHeight()){
                    var ratio = $(this).innerWidth() / $(this).innerHeight();
                }

                if(ratio > 1.9){
                    $(this).addClass('wide');
                } else {
                    $(this).removeClass('wide');
                }

                if(!$(this).hasClass('dce') && $(this).hasClass('wide') && $(this).children('.cardContent').hasClass('haveVisuel')){
                    var initTitle = $(this).find('.title').html();
                    if (initTitle != '') {
                        $(this).find('.taxoLabel').html(initTitle);
                    }
                    $(this).find('.taxoLabel').find('.fa').remove();
                }

                if($(this).innerWidth() < 290 && !sggbisCard.mobileMode){
                    $(this).addClass('smallCard');
                } else {
                    $(this).removeClass('smallCard');
                }

                sggbisCard._appear($(this), ((elt+1)*250));
                $(this).addClass('cardDone');
            });

        }

        return this;
    };

    sggbisCard._appear = function($elt, time){

        setTimeout(function(){
            if( !$elt.hasClass('.cardVisible')){
                $elt.addClass('cardVisible');
                /*
                plus be soin de clamps
                if(!$elt.hasClass('dce')
                    && !$elt.hasClass('pictoCard')
                    && !$elt.hasClass('twitterCards')
                    && !$elt.hasClass('edito')
                    && !$elt.hasClass('esaliaGreenBlock')
                    && !$elt.hasClass('card-rte')
                ){
                    $elt.find('.cardContentTxt').dotdotdot({
                        watch: false,
                        truncate: ($('html').prop('lang') === 'jp') ? "letter" : "word", // en gros pour le JP on peut tronquer par lettre
                    });
                }
                 */
            }
        }, time);

    }

    $(window).bind('load', function(event) {
        //sggbisCard._apply();
    });

    $(window).bind('resize orientationchange', function(event) {
        sggbisCard._checkMobile();
        sggbisCard._apply();
    });


})(jQuery);





;(function($) {

    var keepRatio = $.fn.keepRatio = function(options) {
        keepRatio.elements = this;
        keepRatio.mobileMode = false;
        keepRatio._checkMobile();
        keepRatio._apply();

        return this;
    };

    keepRatio._checkMobile = function(){
        if(($(document).width() < 768)){
            keepRatio.mobileMode = true;
        } else {
            keepRatio.mobileMode = false;
        }
    }

    keepRatio._apply = function() {

        if(this.elements != undefined){
            this.elements.each(function(){

                var dataratio = $(this).data('dimratio');

                if(keepRatio.mobileMode &&  $(this).data('dimratiomobile') != undefined){
                    dataratio = $(this).data('dimratiomobile');
                    if( $(this).data('dimratiomobile') == '0'){
                        dataratio = undefined;
                    }
                }

                if(dataratio != undefined){

                    var gutterWidth =  3 * parseFloat(getComputedStyle(document.documentElement).fontSize);

                    var tmp = dataratio.split('-');
                    var ratio = tmp[0] / tmp[1];

                    var gutter = (tmp[0] - 1) * gutterWidth;
                    var initWith = $(this).get(0).getBoundingClientRect().width - gutter;
                    var newHeight = (initWith / ratio) + ((tmp[1] - 1) * gutterWidth);

                    if($(this).hasClass('homePageCarrousel')){newHeight = newHeight + gutterWidth; }

                    $(this).css("height", newHeight);

                } else {
                    $(this).css("height", 'auto');
                }
            });
        }
        return this;
    };

    $(window).bind('load', function(event) {
        //keepRatio._apply();
    });

    $(window).bind('resize orientationchange', function(event) {
        keepRatio._apply();
        keepRatio._checkMobile();
    });


})(jQuery);


/**
 * [description]
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
(function($) {

    $.fn.cardWallFilters = function(options) {

        var settings = $.extend( {}, $.fn.cardWallFilters.defaults, options );


        return this.each(function() {

            //console.debug('cardWallFilters');

            var $container = $(this);

            $container.find('.summaryFilters select').change(function(e){
                _launchResults();
            });
            $container.find('#filterTextSubmit').click(function(){
                if(!$container.find('#filterTextSubmit').hasClass('disabled')){
                    _launchResults();
                }
            });
            $container.find('.resetFilter').click(function(){
                $(this).prev().val(0);
                _launchResults();
            });

            // Gestion de l'infinite scroll
            if(settings.infiniteScroll){
                $(window).data('cardInfiniteScrollReady', true);
                $(window).scroll(function() {
                    var $btnMore = $container.find('.moreResult');
                    if ($(window).data('cardInfiniteScrollReady') == false) return;
                    if(verge.inViewport($btnMore) && $btnMore.css('display') != 'none'){
                        //console.debug('on lance linfinite scroll');
                        _loadMoreResult();
                    }
                });
            }

            $container.find('.moreResult').on('keypress', function(e) {
               // if enter loadmoreresult
                if (e.keyCode === 13) {
                    _loadMoreResult();
                }
            });

            $container.find('.moreResult').on('click', function(){
                _loadMoreResult();
            });

            $container.find('.tagList, .onePageMenu--summaryFilters').attr('role', 'radiogroup');
            $container.find('.tagList .label, .onePageMenu__item').each(function(){
                if ($(this).is('.label-primary, .active')) {
                    $(this).attr('aria-checked', true)
                } else {
                    $(this).attr('aria-checked', false)
                }
                $(this).attr('role', 'radio');
            });

            $container.find('.tagList .label, .onePageMenu__item').click(function(e){

                // on change le markup en fonction du système de filtre (changement fait pour SGPBInsights)
                if($(this).hasClass('label')){
                    $(this).addClass('label-primary').removeClass('label-default').attr('aria-checked', true)
                        .siblings().removeClass('label-primary').addClass('label-default').attr('aria-checked', false);
                } else {
                    $(this).addClass('active').attr('aria-checked', true)
                        .siblings().removeClass('active').attr('aria-checked', false);
                }

                var datas = {};
                datas['tx_bisgsummary_pi2['+$(this).data('name')+']'] = $(this).data('id');
                _filterResults(datas, false);
                e.preventDefault();

                // on va gérer l'accessibilité, on va déplacement le label pour dire le filtre selectionné
                var $srStatus = $container.find('.sr-only.status');
                if($srStatus.length > 0) {
                    $(this).append($srStatus)
                }

            });


            // on va rajouter un écouteur pour pouvoir falider la recherche via la touche entré
            // cette ecouteur est ajouté au focus sur le champs
            $container.find('#filterText').focus(function(){
                $container.on( 'keydown', function(event) {
                    if(event.which == 13) $container.find('#filterTextSubmit').trigger('click');
                    if($container.find('#filterText').val().length >= 2){
                        $container.find('#filterTextSubmit').removeClass('disabled');
                    } else {
                        $container.find('#filterTextSubmit').addClass('disabled');
                    }
                });
            });


            // supprimé quand on perd le focus
            $container.find('#filterText').blur(function(){
                $container.off('keydown');
            });


            _initFilters();


            /**
             * Action a lancer pour charger du contenu supplémentaire (click sur bouton "more results")
             * @private
             */
            function _loadMoreResult(){

                var $btnMore = $container.find('.moreResult');
                var currentPage = $btnMore.data('page');
                $btnMore.data('page', currentPage + 1);
                $btnMore.addClass('loading');
                var datas = {
                    'tx_bisgsummary_pi2[page]': 	currentPage,
                    'tx_bisgsummary_pi2[text]': 	$container.find('#filterText').val(),
                    'tx_bisgsummary_pi2[itemType]': $container.find('#filterTypeDoc').val(),
                    'tx_bisgsummary_pi2[tags]': 	$container.find('#filterTag').val(),
                    'tx_bisgsummary_pi2[category]': $container.find('#filterCategory').val(),
                    'tx_bisgsummary_pi2[year]': 	$container.find('#filterYear').val(),
                    'tx_bisgsummary_pi2[sorting]':  $container.find('#sentenceSorting').val()
                };
                _filterResults(datas, false, true);
            }


            function _initFilters(){
                var hash = document.location.hash;
                if(hash){
                    var hashInfo = hash.split('-');
                    if(hashInfo[0] == '#tag'){
                        $container.find('.tagList > span[data-id='+hashInfo[1]+']').trigger('click');
                    }
                }
            }


            function _launchResults(){
                var datas = {
                    'tx_bisgsummary_pi2[text]': 	$container.find('#filterText').val(),
                    'tx_bisgsummary_pi2[itemType]': $container.find('#filterTypeDoc').val(),
                    'tx_bisgsummary_pi2[tags]': 	$container.find('#filterTag').val(),
                    'tx_bisgsummary_pi2[category]': $container.find('#filterCategory').val(),
                    'tx_bisgsummary_pi2[year]': 	$container.find('#filterYear').val(),
                    'tx_bisgsummary_pi2[sorting]':  $container.find('#sentenceSorting').val()
                };
                _filterResults(datas);
            }



            function _filterResults(datas, refreshFilter, addResults){

                ////console.debug('_filterResults', datas);

                $(window).data('cardInfiniteScrollReady', false);
                $container.addClass('loading');

                if(addResults == undefined){
                    addResults = false;
                }

                if(addResults){
                    datas['tx_bisgsummary_pi2[removeWrapperToListing]'] = true;
                }

                if(refreshFilter == undefined){
                    var $containerToRefresh = $container.find('.summaryWallAjax');
                    datas['tx_bisgsummary_pi2[refreshFilter]'] = true;
                } else {

                    if($container.hasClass('wallCard--insights') || $container.hasClass('wallCard--webinarsAndParoles-grid') ) {
                        var $containerToRefresh = $container.find('.wallInsights');
                    } else if ($container.hasClass('wallCard--nvbq')) {
                        var $containerToRefresh = $container.find('.wallNvbq');
                    } else {
                        var $containerToRefresh = $container.find('.resultsContainer .wallCardItems');
                    }

                    datas['tx_bisgsummary_pi2[removeWrapperToListing]'] = true;
                }

                datas['no_cache'] = true;
                datas['tx_bisgsummary_pi2[ajaxCall]'] = true;
                datas['tx_bisgsummary_pi2[ajaxMethod]'] = 'refreshResults';
                datas['tx_bisgsummary_pi2[forceConf]'] = settings.forceConf;
                datas['tx_bisgsummary_pi2[idContent]'] = settings.idContent;

                $.ajax({
                    type: "POST",
                    data: datas,
                    url: settings.currentPageLink,
                    dataType: "html",
                    success: function(data) {

                        if(addResults) {

                            $container.find('.card').last().focus();

                            if($container.hasClass('wallCard--isotope')){
                                var $newEls = $(data);
                                $container
                                    .find('.wallCardItems')
                                    .append( $newEls )
                                    .isotope( 'appended', $newEls )

                                // pour pb Insighs
                            } else if ($container.hasClass('wallCard--insights') || $container.hasClass('wallCard--webinarsAndParoles-grid')) {
                                $container.find('.summaryWallAjax .wallInsights__item').last().after(data);
                            } else if ($container.hasClass('wallCard--podcasts')) {
                                $container.find('.summaryWallAjax .cardPodcast').last().after(data);
                            } else if ($container.hasClass('wallCard--nvbq')) {
                                $container.find('.summaryWallAjax .cardNvbq').last().after(data);
                            } else {
                                $container.find('.summaryWallAjax .wallCardRow_card').last().after(data);
                            }

                            // on va ajuster le message de status pour l'accessibilité
                            var $status = $container.find('.wallCard__status');
                            if ($status.length){
                                $status.text(settings.ll.statusAdded);
                            }

                        } else {
                            // on réinitialise les pages du boutons more car nous avons reset les resultats
                            $container.find('.moreResult').data('page', 2);
                            $containerToRefresh.html(data);
                            // petit tweek pour SGPBInsight, au click on scroll pour mettre les filtre en haut de l'écran
                            if($container.hasClass('wallCard--insights')){
                                scrollToItem($container.find('.summaryFilters'));
                            // on lance un placement isotope
                            } else if ($container.hasClass('wallCard--isotope')){
                                $container.find('.wallCardItems').isotope('destroy').isotope({
                                    layoutMode: 'packery',
                                    itemSelector: '.card',
                                    percentPosition: true,
                                    packery: {
                                        columnWidth: '.grid-sizer'
                                    }
                                });
                            }
                            // ajout d'un focus pour l'accessibilité
                            if ($container.find('.card').length) {
                                $container.find('.card').eq(0)[0].focus();
                            }

                            // on va ajuster le message de status pour l'accessibilité
                            var $status = $container.find('.wallCard__status');
                            if ($status.length){
                                $status.text(settings.ll.statusUpdated);
                            }
                        }


                        $container.find('.card:not(.cardDone)').sggbisCard();
                        $container.cardWall();


                        if($container.find('.summaryWallAjax').find('.card').length < settings.nbTotalResults){
                            $container.find('.moreResult').show();
                        } else {
                            $container.find('.moreResult').hide();
                        }

                        $container.find('.moreResult').removeClass('loading');
                        $container.removeClass('loading');
                        $(window).data('cardInfiniteScrollReady', true);
                    }
                });

            }

        });
    }

    function isFrench() {
        return $('html').attr('lang').includes('fr');
    }

    $.fn.cardWallFilters.defaults = {
        'nbTotalResults' : 0,
        'currentPageLink' : false,
        ll: {
            'statusUpdated': isFrench() ? 'La liste de recherche a été mise à jour par les filtres' : 'Search list has been updated by filters',
            'statusAdded': isFrench() ? 'Informations supplémentaires chargées' : 'Additional informations loaded',
        }
    };
})(jQuery);






/**
 * Gestion des mure de card spéciale SGPRIV
 * @author Pierre Frumillon
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
(function($) {

    $.fn.cardWall = function(options) {

        var settings = $.extend( {}, $.fn.cardWall.defaults, options );

        return this.each(function() {

            var $modalIndex = 0;
            var $focusableContent = 0;
            var contentLoaded = '';
            var $container = $(this);
            var $btnLeft;
            var $spinner;
            var $btnRight;
            var $currentItem;
            var $placeHolder;
            var currentItemId;
            var fixedHeaderIsActive = false;
            var $cardClicked = false
            var listItems = [];
            var svgClose = '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-7x"><path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z" class=""></path></svg>';
            var svgLeft = '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-left fa-w-14 fa-7x"><path fill="currentColor" d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z" class=""></path></svg>';
            var svgRight = '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14 fa-7x"><path fill="currentColor" d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z" class=""></path></svg>';

            $container.find(settings.cardItem).each(function(){

                // on rajoute ceci pour l'accessibillité 2022
                if (!$(this).hasClass('cardNvbq')) {
                    const role = $(this).data('ajax') ? 'button' : 'link';
                    $(this).attr('role', role)
                }

                $(this).find('a').click(function(event){
                    event.stopPropagation();
                });

                $(this).unbind('click');

                listItems.push($(this).attr('id'));
                if(settings.addSpinnerOnCard) {
                    if($(this).find('.spinner').length == 0){
                        $(this).append('<div class="spinner"><span class="fa fa-refresh fa-spin"></span></div>');
                    }
                }
                $(this).click(function(){

                    if($(this).data('filelink') != undefined){
                        window.open($(this).data('filelink'));
                        return false;
                    } else if($(this).data('ajax') != undefined){
                        _clickOnCard($(this));
                        return false;
                    } else {

                        if(!$(this).data('href')) return false;

                        // si on est en mode front end editing on change l'url de la page parente car nous somme en moe iframe
                        if(GBIS.frontend_editing){
                            window.parent.location.href = $(this).data('href');
                            return false;
                        }

                        var n = $(this).data('href').indexOf("http");

                        // if(n === -1){
                        //     document.location.href = '/'+$(this).data('href');
                        // } else{
                            if($(this).data('hrefblank')){
                                window.open($(this).data('href'), '_blank');
                            }else{
                                document.location.href = $(this).data('href');
                            }
                        // }
                    }
                });
            });


            function _loadContentFromNav(){
                _ajustNavigation();
                _loadAjaxContent();
                $spinner.removeClass('loading');
                $placeHolder.find('.container').removeClass('loadingNext').removeClass('loadingPrevious');
            }

            function _loadContentFromCard($item){

                let placeHolder = document.createElement('div');
                $(placeHolder).addClass('cardPlaceHolder');
                $(placeHolder).addClass('trans');
                $(placeHolder).append('<button aria-label="'+settings.ll.close+'" class="closeBtn" tabindex="1">'+svgClose+'</button>');
                $(placeHolder).append('<div class="container">');
                $(placeHolder).append('<div class="spinner"><span class="fa fa-refresh fa-spin"></span></div>');
                $(placeHolder).append('<button aria-label="'+settings.ll.prev+'" class="leftBtn navBtn"><div>'+svgLeft+'</div></button>');
                $(placeHolder).append('<button aria-label="'+settings.ll.next+'" class="rightBtn navBtn"><div>'+svgRight+'</div></button>');
                $(placeHolder).attr('role', 'dialog');
                $(placeHolder).attr('aria-modal', 'true');

                var itemOffset = $item.offset();
                var headerHeight = _getHeaderHeight();

                $(placeHolder).css('width', $item.innerWidth() + 2);
                $(placeHolder).css('height', $item.innerHeight()+ 2);
                $(placeHolder).css('left', itemOffset.left);
                $(placeHolder).css('top', itemOffset.top - $(window).scrollTop());

                $('#main').append($(placeHolder));
                $btnLeft = $(placeHolder).find('.leftBtn');
                $btnRight = $(placeHolder).find('.rightBtn');
                $spinner = $(placeHolder).find('.spinner');
                $placeHolder = $(placeHolder);
                _ajustNavigation();
                // $(placeHolder).find('.closeBtn').css('top', headerHeight + 20);

                $('.cardPlaceHolder .closeBtn').click(function(){
                    _closeContent();
                });
                $btnRight.click(function(){
                    _loadNextContent();
                });
                $btnLeft.click(function(){
                    _loadPreviousContent();
                });

                //var windowHeight = window.screen.height;


                if($('.fixedheader').hasClass('active')){
                    fixedHeaderIsActive = true;
                    $('.fixedheader').fadeOut();
                }


                setTimeout(function() {

                    let topPlaceHolder = (viewportSize().width < 801) ?  60 : 127;
                    var windowHeight = viewportSize().height;
                    var placeHolderHeight = windowHeight - topPlaceHolder;

                    $(placeHolder).css('position', 'fixed');
                    $(placeHolder).css('left',	'0');
                    $(placeHolder).css('top',	 '0');
                    $(placeHolder).css('width', '100%');
                    $(placeHolder).css('height', '100vh');
                    $('body').addClass('noscroll haveCardPopin');
                }, 250);

                setTimeout(function() {
                    _loadAjaxContent();
                }, 1000);




            }

            function _modalFocusKeydown(e) {

                let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                if (!isTabPressed) {
                    return;
                }

                if (e.shiftKey) { // if shift key pressed for shift + tab combination
                    if ($modalIndex > 0) {
                        $modalIndex--;
                    } else {
                        $modalIndex = $focusableContent.length - 1;
                    }
                } else { // if tab key is pressed
                    if ($modalIndex < $focusableContent.length - 1) {
                        $modalIndex ++
                    } else {
                        $modalIndex = 0;
                    }
                }

                $focusableContent[$modalIndex].focus();
                e.preventDefault();
            }


            function _trapFocus(){
                // un peu d'acceessibilité
                // on "trap" le focus à l'intérieur de la modal
                $('.sgnews_single__socials a').attr('tabindex', '-1');

                var  focusableElements = 'button, [href]:not([tabindex="-1"], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                var modal = $placeHolder[0] // select the modal by it's id
                var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal

                $modalIndex = 0;
                $focusableContent = modal.querySelectorAll(focusableElements)
                document.addEventListener('keydown', _modalFocusKeydown);

                firstFocusableElement.focus();
            }

            function _loadPreviousContent(){

                var previousItem = _getPreviousContentItem();
                if(previousItem){
                    $placeHolder.find('.container').addClass('loadingPrevious');
                    $btnLeft.addClass('loading');
                    $spinner.addClass('loading');
                    _getAjaxContent(previousItem);
                }
            }

            function _loadNextContent(){
                var nextItem = _getNextContentItem();
                if(nextItem){
                    $placeHolder.find('.container').addClass('loadingNext');
                    $btnRight.addClass('loading');
                    $spinner.addClass('loading');
                    _getAjaxContent(nextItem);
                }
            }


            function _getPreviousContentItem(){
                var index = listItems.indexOf($currentItem.attr('id'));
                if(index == 0){
                    return false;
                } else {
                    return $('#'+listItems[index - 1]);
                }
            }

            function _getNextContentItem(){
                var index = listItems.indexOf($currentItem.attr('id'));
                if(index < (listItems.length - 1)){
                    return $('#'+listItems[index + 1]);
                } else {
                    return false;
                }
            }


            function _closeContent(){

                $placeHolder.addClass('toHide');

                var itemOffset = $currentItem.offset();

                if(fixedHeaderIsActive){
                    $('.fixedheader').fadeIn();
                }

                setTimeout(function() {
                    $placeHolder.css({
                        'opacity': 0.5,
                        'width': $currentItem.innerWidth() + 4,
                        'height': $currentItem.innerHeight()+ 4,
                        'left': itemOffset.left,
                        'top': itemOffset.top - $(window).scrollTop() - 1
                    });
                    $('body').removeClass('noscroll haveCardPopin');
                }, 500);

                setTimeout(function() {
                    $placeHolder.remove();
                    $container.find(settings.cardItem).removeClass('loading');
                }, 1000);

                if ($cardClicked) {
                    $cardClicked.focus()
                }

                document.removeEventListener('keydown', _modalFocusKeydown);
            }


            function _getHeaderHeight(){
                var hh;
                // cas mobile avec le scroll figé
                //if($('.mainHeader').hasClass('scroll-to-fixed-fixed')){
                if(viewportSize().width < 801){
                    hh = $('.mainHeader').innerHeight();
                    // autre cas
                } else {

                    hh = $('.mainHeader').innerHeight() - $(window).scrollTop();
                    if(hh < $('.subHeader').innerHeight() && !$('body').hasClass('hamburgermenu')){
                        hh = $('.subHeader').innerHeight();
                    }

                    if($('body').hasClass('hamburgermenu')){
                        hh = $('.mainHeader').innerHeight() - $(window).scrollTop();
                        if(hh < 0) hh = $('.mainHeader').innerHeight();
                    }
                }

                return hh;
            }

            function _loadAjaxContent(){

                $placeHolder.find('.container').html(contentLoaded);
                initAddthisGaEvents('.addthis_toolbox.inpopin a');
                initContentsAssets();
                _trapFocus();
            }


            function _getAjaxContent($item){

                if($item.find('.googleLink').length){
                    gaTrackPage($item.find('.googleLink').data('href'));
                }

                var ajaxLink = $item.data('ajax');
                if(ajaxLink.charAt(0) == '#'){
                    contentLoaded = $(ajaxLink).html();
                    _loadContent($item);
                } else {
                    $.ajax({
                        url: $item.data('ajax'),
                        data: {
                        },
                        type: "POST",
                        success: function(data) {
                            contentLoaded = data;
                            _loadContent($item);
                        }
                    });
                }


            }


            /**
             * on va ajuster les titles des boutons next / back pour l'accessibilité
             * on va également activer ou non les bouton next et right de la popin
             * @private
             */
            function _ajustNavigation(){

                var previousContentItem = _getPreviousContentItem()
                var nextContentItem = _getNextContentItem()

                if (!previousContentItem) {
                    $btnLeft.addClass('disabled').attr('disabled', 'disabled');
                } else {
                    $btnLeft.removeClass('disabled').removeAttr('disabled');
                    if(previousContentItem.data('modalname')) {
                        $btnLeft.attr('aria-label', settings.ll.prev + ': ' + settings.ll.show + ' ' +  previousContentItem.data('modalname'))
                    }
                }

                if (!nextContentItem) {
                    $btnRight.addClass('disabled').attr('disabled', 'disabled');
                } else {
                    $btnRight.removeClass('disabled').removeAttr('disabled');
                    if(nextContentItem.data('modalname')) {
                        $btnRight.attr('aria-label', settings.ll.next + ': ' + settings.ll.show + ' ' +  nextContentItem.data('modalname'))
                    }
                }

                $btnLeft.removeClass('loading');
                $btnRight.removeClass('loading');
            }


            function _loadContent($item){

                $currentItem = $item;
                currentItemId = $item.data('ref');

                if($('body').hasClass('noscroll')){
                    _loadContentFromNav();
                } else {
                    _loadContentFromCard($item);
                }


                // ajout accessibilité on gère les infos pour la modal ouverte
                $placeHolder.attr('role', 'dialog');
                // console.debug($item.data('modalname'), $item)
                if($item.data('modalname')) {
                    $placeHolder.attr('aria-label', $item.data('modalname'));
                }


            }


            function _clickOnCard($item){
                $cardClicked = $item
                $item.toggleClass('loading');
                _getAjaxContent($item);
            }

        });
    }

    function isFrench() {
        return $('html').attr('lang').includes('fr');
    }

    $.fn.cardWall.defaults = {
        cardItem: ".card",
        addSpinnerOnCard: true,
        ll: {
            'close': isFrench() ?  'Fermer la fenêtre modale' : 'Close modal window',
            'prev': isFrench() ? 'Précédent' : 'Previous',
            'next': isFrench() ? 'Suivant' : 'Next',
            'show': isFrench() ? 'Voir' : 'Show',
        }
    };


})(jQuery);
